import { render, staticRenderFns } from "./register-process.vue?vue&type=template&id=4b9d9c0f&scoped=true&"
import script from "./register-process.vue?vue&type=script&lang=js&"
export * from "./register-process.vue?vue&type=script&lang=js&"
import style0 from "./register-process.vue?vue&type=style&index=0&id=4b9d9c0f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9d9c0f",
  null
  
)

export default component.exports